module.exports = __webpack_public_path__ + "media/images/icons/icon_instagram-31bfda976127411d8b02ee372af09c7d.png";